module.exports = __webpack_public_path__ + "static/media/right.7d9bcd71.png";